export default class ParticipationListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, $mdDialog, $cookies, $stateParams, WorkPlanModalSrv, GlobalConfig, Requests, $sessionStorage) {
    var participationListVm = this
    participationListVm.mainLabel = 'Participación en comités'
    participationListVm.gradRoleClass = 'grad-4'
    participationListVm.participationList = []
    participationListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    participationListVm.$sessionStorage = $sessionStorage
    participationListVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]

    // VARIABLES
    participationListVm.viewLoaded = true
    participationListVm.active = GlobalConfig.generals.active
    participationListVm.notActive = GlobalConfig.generals.notActive
    participationListVm.planningFinish = true
    $scope.classPlanning = ''
    participationListVm.inReview = 0
    participationListVm.feedback = 0
    participationListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory
    participationListVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

    // METHODS
    participationListVm.participation = []
    participationListVm.confirmDeleteParticipation = confirmDeleteParticipation
    participationListVm.finalizePlan = finalizePlan
    participationListVm.updateView = updateView
    participationListVm.getGeneralsWorkplan = getGeneralsWorkplan
    participationListVm.bitacora = bitacora

    function updateView () {
      participationListVm.viewLoaded = false
      $timeout(() => {
        participationListVm.viewLoaded = true
      }, 400)
    }

    activate()

    function activate () {
      let header = {
        teacherId: $cookies.getObject('currentUser').teacherId,
        workplanId: $cookies.getObject('currentUser').workplanId
      }

      if(participationListVm.workPlanGeneralList != undefined){

        participationListVm.status = participationListVm.workPlanGeneralList.wokplanTeacherStatus[0]
        participationListVm.stages = participationListVm.workPlanGeneralList.stages
        participationListVm.inReview = participationListVm.status.reviewed
        participationListVm.feedback = participationListVm.status.feedbackReviewed
        participationListVm.workplanTeacherId = participationListVm.status.workplanTeacherId
        isPlanning(participationListVm.status, participationListVm.stages)

        if(participationListVm.feedback && !participationListVm.planningFinish){
          getDataFormCommitteeReject(header)
        }else{
          getDataFormCommittee(header)
        }
      }else{
        getGeneralsWorkplan(header).then((promise) => {
          if(participationListVm.feedback && !participationListVm.planningFinish){
            getDataFormCommitteeReject(header)
          }else{
            getDataFormCommittee(header)
          }
        })
      }
      updateView()
    }

    function getDataFormCommittee (header){
      WorkPlanSrv.getDataFormCommittee.get(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          participationListVm.participationList = dataReturn.committee
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function getDataFormCommitteeReject (header){
      WorkPlanSrv.getDataFormCommitteeReject.get(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          participationListVm.participationList = dataReturn.committee
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function finalizePlan () {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.dataArray = [
            {activity: 'Docencia', time: '10', percentage: '10%'},
            {activity: 'Gestión académica administrativa', time: '15', percentage: '11%'},
            {activity: 'Consolidación de cuerpo profesoral', time: '0', percentage: '0%'},
            {activity: 'Investigación e Innovación', time: '100', percentage: '81%'},
            {activity: 'Extensión y relaciones interinstitucionales', time: '0', percentage: '0%'}
          ]

          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./finalizePlanModal.html'),
        clickOutsideToClose: false
      })
    }

    function confirmDeleteParticipation (itemParticipation) {
      let participationArray = participationListVm.participationList.indexOf(itemParticipation)
      let participationName = itemParticipation.comiteeName
      let participationId = itemParticipation.comiteeId
      let workplanTeacherActivityId = itemParticipation.workplanTeacherActivityId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.participationArrayCode = participationArray
          ctrlModalVM.participationName = participationName
          ctrlModalVM.participationId = participationId
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.deleteParticipation = function () {
            WorkPlanSrv.deleteParticipation.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
             .$promise.then(function (dataReturn) {
               if (dataReturn.status) {
                 showSuccessDialog(ctrlModalVM.participationName)
                 updateView()
                 WorkPlanIndicatorSrv.setVariable(true)
                 participationListVm.participationList.splice(ctrlModalVM.participationArrayCode, 1)
                 $mdDialog.hide()
               } else {
                 console.log('Comunications problem with the server')
               }
             }, function (data) {

             })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteParticipationModal.html'),
        clickOutsideToClose: false
      })
    }

    function showSuccessDialog(name){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : name,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          participationListVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          participationListVm.status = dataReturn.data.wokplanTeacherStatus[0]
          participationListVm.stages = dataReturn.data.stages
          participationListVm.inReview = participationListVm.status.reviewed
          participationListVm.feedback = participationListVm.status.feedbackReviewed
          participationListVm.workplanTeacherId = participationListVm.status.workplanTeacherId
          isPlanning(participationListVm.status, participationListVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      participationListVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          participationListVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == participationListVm.active){        
          participationListVm.planningFinish = true
          if (participationListVm.startDateReview < participationListVm.currentDate || status.reviewedFinish == participationListVm.active){
            participationListVm.planningFinish = true
          }else if (status.reviewedReject == participationListVm.active){
            participationListVm.planningFinish = false
          }
        } else {
          participationListVm.planningFinish = false
        }
      }else{
        participationListVm.planningFinish = true
      }

      $scope.classPlanning = (participationListVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.committeeParticipation,
        workplanTeacherId: participationListVm.workplanTeacherId
      }
      entries.title = 'Cargos por Delegación'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
}

ParticipationListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', '$mdDialog', '$cookies', '$stateParams', 'WorkPlanModalSrv', 'GlobalConfig', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/committeeParticipation/list/participationsListCtrl.js